"use client";
import React from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import logo from "../../assets/salontym_loder.png";
import Image from "next/image";

interface GetAppNotificationProps {
  setVisible: (visible: boolean) => void;
  visible: boolean;
}

const GetAppNotification: React.FC<GetAppNotificationProps> = ({
  setVisible,
  visible,
}) => {
  const handleCloseNotification = () => {
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      sx={{
        display: { xs: "flex", sm: "none" },
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "#005c01", // Maroon background
        color: "white",
        padding: "8px",
        maxWidth: "100%",
        height: "65px",
      }}
    >
      {/* Logo */}
      <Image
        src={logo}
        alt="SalonTym"
        width={500}
        height={500}
        style={{
          width: 50,
          height: 50,
          borderRadius: "8px",
        }}
      />

      {/* Text Content */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "start",
          alignItems: "start",
        }}
      >
        <Typography variant="body2" fontWeight="bold">
          Download the App
        </Typography>
        <Typography variant="caption" sx={{ textWrap: "nowrap" }}>
          for exclusive features & experience
        </Typography>
      </Box>

      {/* "Get App" Button */}
      <Button
        variant="contained"
        sx={{
          backgroundColor: "white",
          color: "#15741a",
          fontWeight: "bold",
          textTransform: "none",
          borderRadius: "20px",
          padding: "4px 8px",
          marginRight: "10px",
          "&:hover": { backgroundColor: "#f0f0f0" },
          fontSize: "12px",
        }}
        onClick={() => {
          const userAgent = navigator.userAgent || navigator.vendor;
          const isIOS = /iPad|iPhone|iPod/.test(userAgent);
          const isAndroid = /Android/.test(userAgent);

          if (isIOS) {
            window.location.href =
              "https://apps.apple.com/in/app/salontym-salon-at-home/id6444617786";
          } else if (isAndroid) {
            window.location.href =
              "https://play.google.com/store/apps/details?id=com.tym.salon.salontym&hl=en_IN";
          } else {
            window.location.href =
              "https://play.google.com/store/apps/details?id=com.tym.salon.salontym&hl=en_IN";
          }
        }}
      >
        Get App
      </Button>

      {/* Close Button */}
      <IconButton
        onClick={handleCloseNotification}
        sx={{ color: "white", padding: "0px" }}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export default GetAppNotification;
